module.exports = __webpack_public_path__ + "static/media/marsbar.65354e5c.svg";